module.exports = __webpack_public_path__ + "media/images/markisen-4e8b6a087965871b936abf0b94bcf47d.jpg";